module.exports = __webpack_public_path__ + "img/nine.a5ca7372.svg";